var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifictionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_1043_12303)",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0509 11.8452L17.2514 11.8048V11.6002V11.0001C17.2514 10.5881 17.5895 10.25 18.0015 10.25C18.4135 10.25 18.7516 10.5881 18.7516 11.0001V11.6002V11.8048L18.9522 11.8452C21.1178 12.2822 22.752 14.2015 22.752 16.5007V17.0907C22.752 18.6221 23.3145 20.1009 24.3247 21.2465L24.3249 21.2468L24.555 21.5068L24.5549 21.5068L24.5592 21.5115C24.7576 21.7246 24.8052 22.0366 24.6838 22.3097C24.5644 22.5784 24.2946 22.7513 24.0021 22.7513H12.0009C11.7049 22.7513 11.4189 22.5655 11.3106 22.3128C11.1972 22.0482 11.2447 21.7225 11.437 21.508L11.4381 21.5068L11.6675 21.2474C11.6676 21.2473 11.6677 21.2472 11.6678 21.2471C12.6886 20.1012 13.251 18.622 13.251 17.0907V16.5007C13.251 14.2015 14.8852 12.2822 17.0509 11.8452ZM16.7605 25.2472C16.4942 24.9737 16.3226 24.6239 16.2692 24.2514H18.0015H19.7339C19.6806 24.6228 19.5099 24.9716 19.2449 25.2448C18.9111 25.5685 18.4644 25.7516 18.0015 25.7516C17.5326 25.7516 17.0793 25.5745 16.7605 25.2472Z",
    fill: "url(#paint1_linear_1043_12303)",
    stroke: "url(#paint2_linear_1043_12303)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_12303",
    x1: 3.9164e-7,
    y1: 2.57141,
    x2: 36.7288,
    y2: 3.52836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_12303",
    x1: 11,
    y1: 11.143,
    x2: 25.2857,
    y2: 11.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1043_12303",
    x1: 11,
    y1: 11.143,
    x2: 25.2857,
    y2: 11.4686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifictionIcon);
export default __webpack_public_path__ + "static/media/notifiction-icon.77b2a14b7d338c3cc95c742003a68cce.svg";
export { ForwardRef as ReactComponent };